import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/add-hotel-offline-order',
      name: 'admin-add-hotel-offline-order',
      component: () => import(/* webpackChunkName: "page-admin-hotel-offlin-order-add-hotel-offline-order" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "添加酒店线下订单"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "酒店线下订单管理"
                                        },
                                        {
                                                  name: "添加酒店线下订单"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
